import { render, staticRenderFns } from "./confirmChangePaper.vue?vue&type=template&id=e3a9013e&scoped=true&"
import script from "./confirmChangePaper.vue?vue&type=script&lang=js&"
export * from "./confirmChangePaper.vue?vue&type=script&lang=js&"
import style0 from "./confirmChangePaper.vue?vue&type=style&index=0&id=e3a9013e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a9013e",
  null
  
)

export default component.exports